import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgHomeFilled = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.10094 1.13405C7.33566 0.955317 7.66434 0.955317 7.89906 1.13405L13.7491 5.58859C13.9074 5.70916 14 5.89453 14 6.09091V13.0909C14 13.5972 13.7946 14.0828 13.4289 14.4408C13.0632 14.7989 12.5672 15 12.05 15H2.95C2.43283 15 1.93684 14.7989 1.57114 14.4408C1.20545 14.0828 1 13.5972 1 13.0909V6.09091C1 5.89453 1.09261 5.70916 1.25094 5.58859L7.10094 1.13405ZM6.2 13.7273H8.8V8.63636H6.2V13.7273Z"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgHomeFilled)
const IconSvgHomeFilled = createIcon(ForwardRef, 'SvgHomeFilled')
export default IconSvgHomeFilled
